import React from 'react';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import CircularProgress from '@material-ui/core/CircularProgress';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getTitleForQuestion } from '../../../utils/tools';

const MaterialTable = dynamic(() => import('material-table'), {
  ssr: false,
  loading: () => <CircularProgress />,
});
export const QAIssuesTable = (props) => {
  props.rows.splice(5);
  return (
    <>
      <MaterialTable
        columns={[
          {
            title: 'Patient',
            field: 'patient.externalId',
            render: (rowData) => (
              <Link href='/patient/[pid]' as={`/patient/${rowData.patient.id}?eid=${rowData.id}`} key={rowData.id}>
                <a className='single_Link'>{rowData.patient.externalId}</a>
              </Link>
            ),
            width: '10%',
            cellStyle: {
              padding: '15px 0 15px 46px',
            },
          },
          {
            title: 'Form',
            field: 'formTitle',
            width: '20%',
            cellStyle: {
              padding: '15px 0 15px 46px',
            },
          },
          {
            title: 'Study',
            field: 'form.study.name',
            width: '20%',
            cellStyle: {
              padding: '15px 0 15px 46px',
            },
          },
          {
            title: 'QA Issues',
            field: 'issues',
            render: (rowData) => {
              if (rowData.issues.length > 1) {
                const questions = [];
                rowData.issues
                  .sort((a, b) => a.question - b.question)
                  .forEach((issue) => {
                    if (questions.indexOf(issue.question) < 0) questions.push(issue.question);
                  });
                return questions.map((question) => (
                  <Accordion key={question} elevation={0} style={{ margin: '0' }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls='expand-issue-content'
                      id='expand-issues-header'
                      style={{ paddingLeft: '0' }}
                    >
                      <span className='QaIssueQuestion'>{getTitleForQuestion(question, rowData.form.data)}</span>
                    </AccordionSummary>
                    <AccordionDetails style={{ padding: '0 16px' }}>
                      <ul style={{ margin: '0' }}>
                        {rowData.issues.map((iss) => {
                          if (iss.question === question) {
                            return <li key={iss.id}>{iss.comment}</li>;
                          }
                          return null;
                        })}
                      </ul>
                    </AccordionDetails>
                  </Accordion>
                ));
              }
              return rowData.issues.length ? (
                <Collapse key={rowData.id} in hidden={false} onClick={() => {}}>
                  <span className='QaIssueQuestion'>
                    {' '}
                    {getTitleForQuestion(rowData.issues[0].question, rowData.form.data)}
                  </span>
                  <span className='QaIssueComment'>
                    {' '}
                    {rowData.issues[0].comment}
                  </span>
                </Collapse>
              ) : null;
            },
            cellStyle: {
              padding: '15px 0 15px 46px',
            },
          },
        ]}
        data={props.rows}
        options={{
          search: false,
          padding: 'default',
          paging: false,
          showTitle: false,
          toolbar: false,
          sorting: false,
          draggable: false,
          headerStyle: {
            padding: '30px 0 30px 46px',
            color: '#707070',
          },
        }}
      />
    </>
  );
};
